import type { RepairOrderStatus } from "@autoflow/types";
import { Tag } from "antd";
import { useAppConfig } from "../../shared/config/AppConfigProvider";

const colors: Record<RepairOrderStatus, string> = {
  DRAFT: "default", CHECKED_IN: "blue", DIAGNOSIS: "cyan", ESTIMATE: "geekblue",
  WAITING_APPROVAL: "gold", APPROVED: "green", IN_PROGRESS: "processing",
  SUPPLEMENT_REQUIRED: "volcano",
  WAITING_PARTS: "orange", QUALITY_CHECK: "purple", READY_DELIVERY: "lime",
  PAID: "green", CLOSED: "default", CANCELLED: "red"
};

export function statusLabel(status: RepairOrderStatus) {
  return status.replaceAll("_", " ");
}

export function RepairOrderStatusTag({ status }: { status: RepairOrderStatus }) {
  const { text } = useAppConfig();
  const label = status === "DIAGNOSIS"
    ? text.inspection
    : status === "ESTIMATE"
      ? text.estimate
      : status === "SUPPLEMENT_REQUIRED"
        ? text.supplementRequired
        : statusLabel(status);
  return <Tag color={colors[status]}>{label}</Tag>;
}
